<div class="w-full text-center">
  @if (requestState === 'requested' || requestState === 'failed' || requestState === 'verifying') {
    <div class="w-full  text-center">
      <input [formControl]="form.controls.token"
             type="number"
             [placeholder]="'mfa.token_placeholder' | translate"
             class="w-50 px-4 py-2 mb-4 bg-transparent border border-gray-500 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

    <button type="button"
            (click)="onVerifyMfa()"
            [disabled]="form.invalid || requestState === 'verifying'"
            [class.animate-pulse]="requestState === 'verifying'"
            class="w-auto px-10 py-2 bg-gray-600 hover:bg-gray-700 rounded-md text-white font-semibold transition-colors">
      {{ 'mfa.btn_confirm' | translate }}
    </button>

    @if (requestState === 'failed') {
      <div class="pt-6">
        <a (click)="onRequestMfa()">
          {{ 'mfa.btn_request_again' | translate }}
        </a>
      </div>
    }
  } @else {
    <button type="button"
            (click)="onRequestMfa()"
            [disabled]="requestState === 'requesting'"
            [class.animate-pulse]="requestState === 'requesting'"
            class="w-auto px-10 py-2 bg-gray-600 hover:bg-gray-700 rounded-md text-white font-semibold transition-colors">
      {{ 'mfa.btn_request' | translate }}
    </button>
  }
</div>

@if (requestState === 'error') {
  <p class="font-medium text-red-500 dark:text-red-400 pt-6">
    {{ 'mfa.request_error' | translate }}
  </p>
} @else if (requestState === 'failed') {
  <p class="font-medium text-red-500 dark:text-red-400 pt-6">
    {{ 'mfa.request_failed' | translate }}
  </p>
} @else if (requestState === 'requested') {
  <p class="text-gray-500 font-medium pt-6">
    @if (recipient?.email && recipient?.phone) {
      {{ 'mfa.requested_both' | translate : recipient }}
    } @else if (recipient?.email && !recipient?.phone) {
      {{ 'mfa.requested_email' | translate : recipient }}
    } @else if (!recipient?.email && recipient?.phone) {
      {{ 'mfa.requested_phone' | translate : recipient }}
    } @else {
      {{ 'mfa.requested_unknown' | translate }}
    }
  </p>
}



